import React, { useState, useEffect } from "react";
import { array, bool, object, string } from "prop-types";
import Polltype from "../../../story-templates/StoryCard/PolltypeElement";
import get from "lodash/get";

import { getPollingStories } from "../../../helper/api";
import { getCollectionName, getSlug } from "../../../utils/utils";

import RightArrowButton from "../../../atoms/icons/right-arrow-button";
import LeftArrowButton from "../../../atoms/icons/left-arrow-button";
import ScrollSnap from "../../../atoms/ScrollSnap";
import CollectionTitleWithArrow from "../../../atoms/CollectionTitleWithArrow";

import "./organism3.m.css";

const Organism3 = ({ collection, isMobile, sections, domainSlug }) => {
  const [pollElements, setPollElements] = useState(null);
  const [showPoll, setShowPoll] = useState(false);

  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");
  const collectionName = getCollectionName(collection, navigateToTitle);
  const collectionSlug = getSlug(collection, sections, domainSlug, navigateTo);

  const storyFields =
    "headline,slug,url,hero-image-s3-key,hero-image-caption,hero-image-metadata,published-at,story-template,metadata,cards";

  useEffect(() => {
    getPollingStories(collection.slug, storyFields).then((stories) => {
      if (stories.length) {
        processPollElements(stories.slice(0, 5));
      }
    });
    setShowPoll(true);
  }, []);

  // Get all the poll elements and create children/storyelements
  const processPollElements = (stories) => {
    const children = [];
    const pollElementsArray = updatePollElements(stories);

    pollElementsArray.length > 0 &&
      pollElementsArray.forEach((element, index) => {
        children.push(<Polltype key={element["polltype-id"]} id={element["polltype-id"]} />);
      });

    setPollElements(children);
  };

  const updatePollElements = (stories) => {
    const storyPollElements = [];
    stories.forEach(({ story }) => {
      if (
        (story["story-template"] === "poll" || story["story-template"] === "polls") &&
        story.cards &&
        story.cards.length
      ) {
        story.cards.forEach((card) => {
          const cardElements = card["story-elements"];
          if (cardElements) {
            const pollElement = cardElements.find((element) => element.type === "polltype");

            if (pollElement) {
              storyPollElements.push(pollElement);
            }
          }
        });
      }
    });
    return storyPollElements;
  };

  if (!(pollElements && pollElements.length)) {
    return null;
  }

  return (
    <div styleName="wrapper">
      <CollectionTitleWithArrow
        collectionSlug={collectionSlug}
        collectionName={collectionName}
        className="collection-name-arrow"
      />
      {showPoll && (
        <div styleName="pool-scroll">
          <ScrollSnap
            isIndicator={isMobile}
            leftArrow={<LeftArrowButton />}
            rightArrow={<RightArrowButton />}
            src="SixStoriesWithPoll"
          >
            {pollElements}
          </ScrollSnap>
        </div>
      )}
    </div>
  );
};

Organism3.propTypes = {
  collection: object.isRequired,
  isMobile: bool,
  sections: array,
  domainSlug: string,
};

export default Organism3;
